import type { ReactNode } from 'react'

import { ArrowUpRight } from 'lucide-react'
import { siteConfig } from '@/constants/site'

const MINOR = [
    'M0 64 L600 40',
    'M0 182 L600 168',
    'M0 352 L600 330',
    'M70 0 L102 420',
    'M392 0 L364 420',
    'M492 0 L520 420',
    'M0 236 L170 420',
    'M430 0 L600 140'
]

const DarkMap = (): ReactNode => {
    const { contact } = siteConfig

    return (
        <a
            href={contact.maps}
            target='_blank'
            rel='noopener noreferrer'
            aria-label="Open L’Élite in Google Maps (opens in a new tab)"
            className='group relative block overflow-hidden border border-ivory/10 bg-charcoal-2'
        >
            <svg viewBox='0 0 600 420' className='block h-auto w-full' aria-hidden='true'>
                <rect width='600' height='420' fill='#15120f' />

                <path
                    d='M18 26 C 90 8, 170 20, 196 64 C 214 98, 170 132, 112 138 C 60 144, 14 118, 10 78 C 8 56, 10 36, 18 26 Z'
                    fill='rgb(201 171 124 / 0.05)'
                    stroke='rgb(237 230 216 / 0.07)'
                />

                {MINOR.map(path => (
                    <path key={path} d={path} stroke='rgb(237 230 216 / 0.06)' strokeWidth='2' fill='none' />
                ))}

                <path d='M0 286 C 160 270, 420 262, 600 236' stroke='rgb(237 230 216 / 0.11)' strokeWidth='7' fill='none' />
                <path d='M232 0 C 248 140, 262 280, 300 420' stroke='rgb(237 230 216 / 0.1)' strokeWidth='6' fill='none' />
                <path d='M0 118 C 170 136, 380 96, 600 116' stroke='rgb(237 230 216 / 0.08)' strokeWidth='4' fill='none' />

                <path d='M302 214 L344 170 L420 200' stroke='rgb(201 171 124 / 0.35)' strokeWidth='1.5' strokeDasharray='3 5' fill='none' />

                <g>
                    <circle className='pin-pulse' cx='302' cy='214' r='12' fill='rgb(201 171 124 / 0.35)' />
                    <circle cx='302' cy='214' r='13' fill='none' stroke='rgb(201 171 124 / 0.55)' />
                    <circle cx='302' cy='214' r='5' fill='#c9ab7c' />
                </g>

                <text
                    x='430'
                    y='204'
                    fill='#ede6d8'
                    style={{ fontFamily: 'var(--font-app-heading, Georgia, serif)', fontSize: '26px' }}
                >
                    L’<tspan fontStyle='italic' fill='#e6cfa3'>É</tspan>lite
                </text>

                <text
                    x='430'
                    y='226'
                    fill='rgb(237 230 216 / 0.5)'
                    style={{ fontSize: '10px', letterSpacing: '0.24em' }}
                >
                    {contact.area.toUpperCase()}
                </text>

                <g transform='translate(560 380)'>
                    <circle r='14' fill='none' stroke='rgb(237 230 216 / 0.15)' />
                    <path d='M0 -9 L4 4 L0 1 L-4 4 Z' fill='rgb(201 171 124 / 0.7)' />
                </g>
            </svg>

            <span className='caps absolute bottom-4 left-4 flex items-center gap-2 bg-ink/70 px-3 py-2 text-ivory/80 backdrop-blur-sm transition-colors duration-500 group-hover:text-brass-bright md:bottom-5 md:left-5'>
                Open in Google Maps
                <ArrowUpRight aria-hidden='true' className='size-3.5' strokeWidth={1.5} />
            </span>
        </a>
    )
}

export default DarkMap
